module.exports = __webpack_public_path__ + "img/trash.4ddab90a.svg";